import styled, { css } from "styled-components";
import { breakpoints } from "../../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 1280px;
  margin: 80px 0px 0px 0px;
  background-color: var(--white);
  display: none;

  ${(props) =>
    props.hidden === "active" &&
    css`
      display: none !important;
    `};

  // Carousel Image
  img {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    margin: 0px 0px 33px 0px;
  }

  // Arrows Button
  button {
    opacity: 100 !important;
    padding: 15px !important;
    transition: 0.2s all !important;
  }

  button::before {
    border: none !important;
    content: url("images/home/carousel/arrows/arrowR.svg") !important;
  }

  button:nth-child(2)::before {
    content: url("images/home/carousel/arrows/arrowL.svg") !important;
  }

  button:hover {
    background-color: transparent !important;
    transform: scale(1.3) !important;
  }

  // Indicators
  .color-dots {
    background-color: var(--white) !important;
  }

  .dot {
    background: var(--orange) !important;
    box-shadow: none !important;
    width: 14px !important;
    height: 14px !important;
    opacity: 1 !important;
    -webkit-filter: grayscale(100%);
    filter: grayscale(100%);
  }

  // Indicators Selected
  .selected {
    box-shadow: none !important;
    opacity: 1 !important;
    -webkit-filter: grayscale(0%);
    filter: grayscale(0%);
  }

  a {
    display: block;
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    max-width: 450px;
    display: block;
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    max-width: 400px;
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    max-width: 88%;
  }
`;

export default Container;
